import ActionsForm from '@/shared/mixins/actionsForm'
import HeadDetailsGama from '@/views/private/realestate/components/HeadDetails.vue'
import Toaddbroker from '../toaddbroker/toaddbroker.vue'
import brokerlink from '../brokerlink/brokerlink.vue'
import AccreditedbrokerRepository from '@/shared/http/repositories/realestate/accreditedbroker'
import { toast, loading } from '@/shared/utils/UIHelper'
export default {
  name: 'Tablebrokers',
  props: ['id'],
  mixins: [ActionsForm],
  components: {HeadDetailsGama, Toaddbroker, brokerlink},

  data () {
    return {
      head: ['TIPO', 'NOME', 'CPF', 'CRECI', 'CIDADE', 'UF', 'STATUS', 'DT. DE CADASTRO', ''],
      status: '',
      databrower: []
    }
  },
  mounted () {
    this.getAllBrokerByAccredited()
  },
  methods: {
    openModal () {
      this.$refs.Toaddbroker.show()
    },
    brokerlink () {
      this.$refs.brokerlink.show()
    },
    getAllBrokerByAccredited () {
      AccreditedbrokerRepository.GetAllPaging(this.id, this.$refs.tableGrids.pagingLimit, this.$refs.tableGrids.pagingIndex)
        .then(Response => {
          this.databrower = Response.data.data
          this.$refs.tableGrids.LoadAllByData(Response)
        })
        .catch(Error => console.log(Error))
    },
    onChange (data) {
      loading.push()
      AccreditedbrokerRepository.PutInativeBrokerAccredited(data.id)
        .then(Response => {
          this.getAllBrokerByAccredited()
          toast.success(`Corretor/Administrador inativada com sucesso`)
          loading.pop()
        })
        .catch(Error => {
          toast.error(`Erro ao inativar o Corretor/Administrador`)
          loading.pop()
        })
    },

    deleteBrokerAccredited (data) {
      AccreditedbrokerRepository.DeleteBrokerAccredited(data.id)
        .then(res => {
          if (res.status === 200) {
            toast.success(`Corretor/Administrador deletado com sucesso`)
            loading.pop()
            this.getAllBrokerByAccredited()
          }
        })
        .catch(() => {
          toast.success(`Erro ao deletar a Corretor/Administrador`)
          loading.pop()
        })
    },
    edit (obj) {
      this.$refs.Toaddbroker.show(obj)
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/realestate/accredited/components/tablebrokers/tablebrokers.js